import React from "react";
import { useNavigate } from "react-router-dom";
import ConfirmImg from "../../assets/images/confirm.svg";
import dateIcon from "../../assets/images/dateGray.png";
import timeIcon from "../../assets/images/timeGray.png";
import "./confirmModel.css";

const RequestConfirmModel = ({ onClose, date, time }) => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    onClose();           // Close the modal
    navigate("/");       // Navigate to home
  };

  return (
    <div className="confirmModelContainer">
      <div className="confirmModelWrapper px-4">
        <div className="flex flex-col w-full justify-center items-center text-center text-neutral-400 text-base py-4 px-6">
          <div className="mb-2">
            <img src={ConfirmImg} alt="Confirmation" />
          </div>
          <div className="mt-3">
            <h1 className="text-2xl font-bold text-black">Request Shared!</h1>
            <p className="pt-4 pb-6 border-b-2">
              We have received your appointment request and we will be in touch with you with the confirmation very soon.
              Please contact us on +917949106799 if urgent
            </p>
          </div>

          <div className="mt-4 mb-2 w-full">
            <div className="flex p-1 justify-center items-center">
              <p className="px-2 py-1 border-r-2 flex items-center">
                <img
                  src={dateIcon}
                  alt="Date Icon"
                  className="inline-block w-5 h-5 mx-1"
                />
                {date}
              </p>
              <p className="px-2 py-1 flex items-center">
                <img
                  src={timeIcon}
                  alt="Time Icon"
                  className="inline-block w-5 h-5 mx-1"
                />
                {time}
              </p>
            </div>
          </div>

          {/* Back to Home Button */}
          <button className="back-butt" onClick={handleBackToHome}>
            Back To Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestConfirmModel;
